/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Ctiproviderhuburlclientsecret5Inputs */

const en_entity_ctiproviderhuburlclientsecret5 = /** @type {(inputs: Entity_Ctiproviderhuburlclientsecret5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CTI Provider Hub Client Secret`)
};

const de_entity_ctiproviderhuburlclientsecret5 = /** @type {(inputs: Entity_Ctiproviderhuburlclientsecret5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CTI Provider Hub Client Secret`)
};

/**
* | output |
* | --- |
* | "CTI Provider Hub Client Secret" |
*
* @param {Entity_Ctiproviderhuburlclientsecret5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_ctiproviderhuburlclientsecret5 = /** @type {((inputs?: Entity_Ctiproviderhuburlclientsecret5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Ctiproviderhuburlclientsecret5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_ctiproviderhuburlclientsecret5(inputs)
	return de_entity_ctiproviderhuburlclientsecret5(inputs)
});
export { entity_ctiproviderhuburlclientsecret5 as "entity_ctiProviderHubUrlClientSecret" }